<template>
  <div class="m-card-primary m-the-modal-content">
    <div>
      <header class="m-the-modal-header">
        <h5>{{ satelite.titulo }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>

      <!-- height-auto: la seccion normal tiene max-height y saca scroll -->
      <section
        key="modalSection"
        class="m-the-modal-section-height-auto m-satellites-modal"
      >
        <img
          v-if="satelite.imagen"
          class="m-satellites-modal-image"
          :alt="satelite.titulo"
          :src="satelite.imagen"
        >

        <p class="m-satellites-modal-state">
          <span
            :class="satelite.activo ? 'text-color-success' : 'text-color-danger'"
          >
            <i :class="[satelite.activo ? 'fas fa-check' : 'fas fa-ban', 'font-size-small']"></i>
            {{ satelite.activo
              ? $t('mEditionBillingArtificialIntelligence.card.activo')
              : $t('mEditionBillingArtificialIntelligence.card.inactivo') }}
          </span>
        </p>

        <h6 class="m-satellites-modal-subtitle">
          {{ $t('mEditionBillingArtificialIntelligence.modalDetail.caracteristicas') }}
        </h6>

        <ul class="m-satellites-modal-limits">
          <li
            v-for="caracteristica in caracteristicas"
            :key="caracteristica.key"
          >
            <span>{{ caracteristica.label }}</span>
            <b>{{ caracteristica.value }}</b>
          </li>
        </ul>
      </section>

      <footer class="m-the-modal-footer m-satellites-modal-footer">
        <a
          href="#"
          class="m-satellites-modal-action"
          @click.prevent="toggleEstado"
        >
          <i :class="satelite.activo ? 'fas fa-ban' : 'fas fa-check'"></i>
          {{ satelite.activo
            ? $t('mEditionBillingArtificialIntelligence.card.actions.desactivar')
            : $t('mEditionBillingArtificialIntelligence.card.actions.activar') }}
        </a>

        <a
          href="#"
          class="m-satellites-modal-action text-color-danger"
          @click.prevent="eliminar"
        >
          <i class="far fa-trash-alt"></i>
          {{ $t('mEditionBillingArtificialIntelligence.card.actions.eliminar') }}
        </a>

        <AtomButtonTheModalCancelAction
          :cancel-text="$t('mEditionBillingArtificialIntelligence.modalDetail.close')"
        />
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingArtificialIntelligenceModalDetail',

  data () {
    return {
      satelite: {},
      sufijo: 'IaMensual',
      tab: 'mensual'
    }
  },

  computed: {
    // Un plan de IA no tiene limites como los Droops: lo unico que lo define son sus creditos y si
    // se renuevan. Siempre el numero real, nunca "ilimitado"
    caracteristicas () {
      const textos = 'mEditionBillingArtificialIntelligence.modalDetail'

      return ['modalidad', 'creditos', 'renovacion'].map(clave => ({
        key: clave,
        label: this.$t(`${textos}.${clave}.label`),
        value: this.$t(`${textos}.${clave}.${this.tab}`, {
          creditos: this.$utils.formatCredits(this.satelite.creditos)
        })
      }))
    }
  },

  created () {
    this.satelite = this.$modal.element.satelite
    this.sufijo = this.$modal.element.sufijo
    this.tab = this.$modal.element.tab
  },

  methods: {
    eliminar () {
      this.$modal.showModal('MoleculeEditionBillingArtificialIntelligenceModalDelete', {
        satelite: this.satelite,
        sufijo: this.sufijo,
        tab: this.tab
      })
    },

    // El PUT lo hace la pantalla, que es la que refresca la lista
    toggleEstado () {
      this.$modal.element.nuevoEstado = !this.satelite.activo
      this.$modal.updateData('toggleEstadoSateliteIa')
    }
  }
}
</script>
